export const ADD = 'entities/user/ADD';
export const STORE = 'entities/user/STORE';
export const CLEAR = 'entities/user/CLEAR';
export const UPDATE_ORGANIZATION = 'entities/user/UPDATE_ORGANIZATION';
export const UPDATE_PROPERTY = 'entities/user/UPDATE_PROPERTY';
